import { render, staticRenderFns } from "./VehiclesShow.vue?vue&type=template&id=e68caa6a&scoped=true"
import script from "./VehiclesShow.vue?vue&type=script&lang=js"
export * from "./VehiclesShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e68caa6a",
  null
  
)

export default component.exports